import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["placeholder", "value"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon")

  return (_openBlock(), _createElementBlock("form", {
    class: "w-100 position-relative",
    onSubmit: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.searchsubmit && $options.searchsubmit(...args)), ["stop","prevent"]))
  }, [
    _createElementVNode("input", {
      ref: "input",
      autocomplete: "off",
      class: "form-control publicsearch",
      placeholder: $options.full_placeholder,
      style: {"padding-left":"40px"},
      type: "search",
      value: $options.query,
      onInput: _cache[0] || (_cache[0] = (...args) => ($options.searchinput && $options.searchinput(...args)))
    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_1),
    _createVNode(_component_icon, {
      class: "position-absolute top-50 translate-middle-y start-0 ms-3",
      name: "SEARCH"
    })
  ], 32 /* NEED_HYDRATION */))
}